// Module
var code = "<div :class=\"{'long-text' : !compact}\"> <textarea v-if=\"!readonly\" :readonly=\"readonly\" :aria-labelledby=\"ariaLabelledby\" rows=\"4\" v-model=\"answer.Text\" @change=\"change()\"></textarea> <p v-if=\"readonly\" :aria-labelledby=\"ariaLabelledby\">{{answer.Text}}</p> </div> ";
// Exports
export default code;